import {Exclude} from 'class-transformer';

import {AnswerOption} from './answer-option';
import {QuestionType} from './question-type';

export class YesNoQuestionType implements QuestionType {

  public name: string = 'yesno';
  @Exclude({toPlainOnly: true})
  public prettyName: string = 'Ja/Nein';
  @Exclude({toPlainOnly: true})
  public icon: string = 'toggle-on';

  public getAnswerOptions(): Array<AnswerOption> {
    return [
      {label: 'Ja', value: 'yes'},
      {label: 'Nein', value: 'no'},
    ];
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/questions/yes-no-question-type.ts